import log from 'loglevel';
import { CookieManager } from './browser-utilities/cookie-manager';

/**
 * Will check if the SDK Debug script should be loaded and loads it if needed in an asynchronous way.
 * @param url source of the debug script
 */
export function preLoadDebugScript(): Promise<void> {
  return new Promise<void>(resolve => {
    if(CookieManager.getCookie('ce.debug')) {
      const sourceUrl = document
        .querySelector('script[src*="ce.js"]')
        ?.getAttribute('src')
        ?.split('ce.js')[0];

      if (!sourceUrl) {
        log.error('Debug script not loaded: Source URL of SDK could not be determined.');
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `${sourceUrl}ce-debug.js`;
      script.onload = () => {
        resolve();
        window.ceDebugger.init(sourceUrl);
      };
      script.onerror = () => resolve();
      document.head.appendChild(script);
    } else {
      resolve();
    }
  });
}
